import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import UpdatePassword from '../forms/UpdatePassword';
import UpdateOwnProfile from '../forms/UpdateOwnProfile';
import { logout, updateProfile, changePassword } from '../../actions/index';
import account from '../../assets/account.png'

class UserMenu extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
            updateProfileModal: false,
            updatePasswordModal: false
        };
        this.toggleUpdateProfileModel = this.toggleUpdateProfileModel.bind(this);
        this.togglePasswordModel = this.togglePasswordModel.bind(this);
    }

    componentWillReceiveProps(nextProps){
        console.log("Received Props")
         console.log(nextProps)
        if (nextProps.logged_user){
             this.setState({
                updateProfileModal: false,
                updatePasswordModal: false
              });
        }
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }

    toggleUpdateProfileModel() {
        this.setState({
            updateProfileModal: !this.state.updateProfileModal
        });
    }

    togglePasswordModel() {
        this.setState({
            updatePasswordModal: !this.state.updatePasswordModal
        });
    }

    render() {
        console.log(this.props);
        const { logout, logged_user } = this.props;

        return (
            <div>
                <Dropdown nav className="d-md-down-none" isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                    <DropdownToggle nav>
                        <img src={account} className="img-avatar" alt="account" />
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-lg" right>
                        <DropdownItem header tag="div" className="text-center"><strong>Hello {logged_user?  logged_user.given_name : "Hello!"}!</strong></DropdownItem>
                        <DropdownItem header tag="div" className="text-center"><strong>{logged_user? logged_user.organization : "Account"}</strong></DropdownItem>
                        <DropdownItem onClick={this.toggleUpdateProfileModel}><i className="icon-user"></i>Edit Profile</DropdownItem>
                        <DropdownItem onClick={this.togglePasswordModel}><i className="icon-key"></i>Change Password</DropdownItem>
                        <DropdownItem onClick={() => logout()}><i className="fa fa-sign-out"></i> Logout</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <div>
                    <Modal isOpen={this.state.updateProfileModal} toggle={this.toggleUpdateProfileModel} className={this.props.className}>
                        <ModalHeader toggle={this.toggleUpdateProfileModel}>Update Profile</ModalHeader>
                        <ModalBody>
                            <UpdateOwnProfile onSubmit={this.props.updateProfile} data={logged_user} />
                        </ModalBody>
                    </Modal>

                    <Modal isOpen={this.state.updatePasswordModal} toggle={this.togglePasswordModel} className={this.props.className}>
                        <ModalHeader toggle={this.togglePasswordModel}>Change Password</ModalHeader>
                        <ModalBody>
                            <UpdatePassword onSubmit={this.props.changePassword} data={logged_user} />
                        </ModalBody>
                    </Modal>

                </div>
            </div>

        );
    }
}

function mapStateToProps({ user, logged_user }) {
    return {
        user,
        logged_user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        logout,
        updateProfile,
        changePassword
    }, dispatch);
}


export default (connect(mapStateToProps, mapDispatchToProps)(UserMenu));



// WEBPACK FOOTER //
// ./src/containers/menus/UserMenu.js